<template>
  <div
    class="wp-body"
    v-loading.fullscreen.lock="loadingOneID"
    :element-loading-text="$t('connecting')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="login">
      <div class="login__wrapper">
        <div class="login__left">
          <div class="login__logo">
            <div class="login__logo-icon">
              <img
                class="login__logo-img"
                src="@/assets/img/icons/logo.svg"
                alt="login logo image"
              />
            </div>
            <div class="login__logo-text">
              <p class="login__logo-title">PASPORT</p>
              <p class="login__logo-subtitle">BINO</p>
            </div>
          </div>

          <div class="login__welcome">
            <h2 class="login__welcome-title">Хуш келибсиз</h2>
            <p class="login__welcome-subtitle">
              Илтимос давом этиш учун тизимга
            </p>
          </div>

          <ValidationObserver ref="login" class="login__form">
            <el-form :model="auth" :rules="rules" ref="auth" class="Form">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="login__form-group">
                  <label class="login__label">{{ $t("login") }}</label>
                  <input
                    :placeholder="$t('login')"
                    type="text"
                    class="login__input"
                    :class="{
                      'is-error': errors.length,
                    }"
                    name="login_name"
                    id="login_inp"
                    v-model="auth.login_name"
                    @keyup.enter="login()"
                  />
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="login__form-group">
                  <label class="login__label">{{ $t("password") }}</label>
                  <input
                    class="login__input"
                    :class="{
                      'is-error': errors.length,
                    }"
                    v-model="auth.password"
                    @keyup.enter="login()"
                    :type="showPassword ? 'text' : 'password'"
                    :placeholder="$t('password')"
                  />
                  <img
                    v-if="!showPassword"
                    @click="showPassword = !showPassword"
                    class="eye_open"
                    src="@/assets/img/eye_password1.svg"
                  />
                  <img
                    v-else
                    @click="showPassword = !showPassword"
                    class="eye_close"
                    src="@/assets/img/eye_password.svg"
                  />
                </div>
              </ValidationProvider>
            </el-form>
            <div class="login__options">
              <label class="login__remember">
                <UIcheckbox /> Эслaб қолиш
              </label>
              <!-- <p href="#" class="login__forgot">Парольни унутдингизми?</p> -->
            </div>

            <div class="login__actions">
              <button
                type="submit"
                id="login-button"
                class="login__btn"
                @click="login()"
                :disabled="loading"
              >
                <span>{{ $t("enter") }}</span>
                <img
                  v-if="!loading"
                  src="@/assets/img/icons/sign-in-button.svg"
                  alt="sign in button"
                />
                <i v-else class="el-icon-loading"></i>
              </button>
            </div>
          </ValidationObserver>

          <div class="login__divider">ёки</div>
          <div class="login__oneid" @click="goToOneID()">
            <img src="@/assets/img/icons/login-oneid.svg" alt="OneID" />
          </div>
          <p class="login__oneid-text">орқали киринг</p>

          <el-dialog
            title="Ж.Ш.Ш.И.Р ни киритинг"
            :visible.sync="openPINFLModal"
            @close="auth.pinfl = ''"
            width="min(600px, 95%)"
          >
            <ValidationObserver ref="pinfl" class="login__form">
              <el-form
                :model="auth"
                :rules="rules"
                ref="auth"
                class="Form"
                @submit.native.prevent
              >
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="login__form-group">
                    <label class="login__label">{{ $t("pinfl") }}</label>
                    <input
                      :placeholder="$t('pinfl')"
                      type="text"
                      maxlength="14"
                      class="login__input"
                      :class="{
                        'is-error': errors.length,
                      }"
                      v-model="auth.pinfl"
                      @input="auth.pinfl = auth.pinfl.replace(/\D/g, '')"
                      @keyup.enter="savePinfl()"
                    />
                  </div>
                </ValidationProvider>
              </el-form>
            </ValidationObserver>
            <span slot="footer" class="dialog-footer">
              <el-button @click="openPINFLModal = false">{{
                $t("cancel")
              }}</el-button>
              <el-button
                type="primary"
                @click="savePinfl()"
                :loading="loadingPinfl"
                >{{ $t("save") }}</el-button
              >
            </span>
          </el-dialog>
        </div>
        <div class="login__right">
          <div class="login__info">
            <div class="login__info-img">
              <img
                src="@/assets/img/emblem.svg"
                alt="O‘zbekiston gerbi"
                class="login__info-logo"
              />
            </div>
            <p class="login__info-text">
              <span>Ўзбекистон Республикасида</span>
              <span>сейсмик фаол ҳудудларида жойлашган</span>
              <span class="login__info-cyan">бино ва иншоотларнинг</span>
              <span class="login__info-indigo"
                >электрон техник паспортларини</span
              >
              <span>шакллантириш тизими</span>
            </p>

            <div class="login__icons">
              <div class="login-icons-img">
                <iconObject1 />
              </div>
              <div class="login-icons-img">
                <iconBuilding4 />
              </div>
              <div class="login-icons-img">
                <iconBuilding1 />
              </div>
              <div class="login-icons-img">
                <iconHydroBuilding />
              </div>
              <div class="login-icons-img">
                <iconBridge1 />
              </div>
              <div class="login-icons-img">
                <iconInvestment2 />
              </div>
              <div class="login-icons-img">
                <iconObject2 />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import UIcheckbox from "@/components/ui/Checkbox.vue";
import iconBridge1 from "../../components/Icons/iconBridge1.vue";
import iconObject1 from "../../components/Icons/iconObject1.vue";
import iconObject2 from "../../components/Icons/iconObject2.vue";
import iconInvestment2 from "@/components/Icons/iconInvestment2.vue";
import iconHydroBuilding from "@/components/Icons/iconHydroBuilding.vue";
import iconBuilding1 from "@/components/Icons/iconBuilding1.vue";
import iconBuilding4 from "@/components/Icons/iconBuilding4.vue";

export default {
  name: "login",
  components: {
    ValidationProvider,
    ValidationObserver,
    UIcheckbox,
    iconObject1,
    iconBridge1,
    iconObject2,
    iconInvestment2,
    iconHydroBuilding,
    iconBuilding1,
    iconBuilding4,
  },
  data() {
    return {
      showPassword: false,
      openPINFLModal: false,
      token: "",
      auth: {
        login_name: null,
        password: null,
        pinfl: null,
      },
      oneIdUrl: "",
      loading: false,
      loadingPinfl: false,
      loadingOneID: false,
      loadingOneIdUrl: false,
      rules: {
        rules: {
          login_name: [
            {
              required: true,
              message: this.$t("add_login"),
              trigger: "change",
            },
          ],
          password: [
            {
              required: true,
              message: this.$t("add_password"),
              trigger: "change",
            },
          ],
          pinfl: [
            {
              required: true,
              message: this.$t("add_pinfl"),
              trigger: "change",
            },
            {
              type: "string",
              min: 14,
              message: this.$t("pinfl_must_be_14_digits"),
              trigger: "blur",
            },
          ],
        },
      },
    };
  },

  mounted() {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
    localStorage.removeItem("role");
    if (this.$route.name === "login-oneid" && this.$route.query.code) {
      this.loginOneid();
    } else {
      this.$store.commit("get_me", "");
      this.$router.push("/login").catch((e) => {
        if (
          e.name !== "NavigationDuplicated" &&
          !e.message.includes(
            "Avoided redundant navigation to current location"
          )
        ) {
          console.log(e);
        }
      });
    }
    this.getOneIdUrl();
  },

  computed: {
    dictionary() {
      return this.$store.state.dictionary;
    },
  },
  methods: {
    login() {
      this.$refs.login.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          axios
            .post("/token/", this.auth)
            .then((response) => {
              if (response.data.status === "failure") {
                this.openPINFLModal = true;
                this.token = response.data.token;
              } else if (response.data.status === "success") {
                window.location.href = response.data.url;
              }
            })
            .catch(() => {
              this.$notify({
                title: "Хато",
                message: "Логин ёки пароль нотўгри киритилган",
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.$notify({
            title: "Хато",
            message: "Бўш бўла олмайди",
            type: "error",
          });
        }
      });
    },
    savePinfl() {
      this.$refs.pinfl.validate().then((valid) => {
        if (valid) {
          this.loadingPinfl = true;
          axios
            .patch("/token/pinfl/", {
              token: this.token,
              pinfl: this.auth.pinfl,
            })
            .then((response) => {
              window.location.href = response.data.url;
            })
            .catch((error) => {
              let message = "";

              if (this.$i18n.locale === "cyr") {
                message =
                  error.response.data?.pinfl?.cyr ||
                  error.response.data?.detail ||
                  `Хатолик ${error.response.status}`;
              } else {
                message =
                  error.response.data?.pinfl?.ru ||
                  error.response.data?.detail ||
                  `Ошибка ${error.response.status}`;
              }

              this.$notify({ title: "Хато", message, type: "error" });
            })
            .finally(() => {
              this.loadingPinfl = false;
            });
        }
      });
    },
    goTo(path) {
      this.$router.push(path).catch((e) => {
        if (
          e.name !== "NavigationDuplicated" &&
          !e.message.includes(
            "Avoided redundant navigation to current location"
          )
        ) {
          console.log(e);
        }
      });
    },
    loginOneid() {
      this.loadingOneID = true;
      axios
        .post("/services/auth/oneid/login/?code=" + this.$route.query.code)
        .then((response) => {
          localStorage.token = response.data.access;
          localStorage.refresh = response.data.refresh;
          localStorage.role = response.data.role;
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${localStorage.token}`;
          const role = response.data.role;
          this.$store.dispatch("get_me");
          this.$store.dispatch("get_version");
          this.$store.commit("set_role", role);
          const homeRoles = [
            "supervisor",
            "reservoir",
            "admin",
            "ministry",
            "org_admin",
            "ministry_admin",
            "main_org_admin",
            "operator",
          ];
          if (homeRoles.includes(role)) {
            if (this.$router.path !== "/") {
              this.goTo("/");
            }
          }
          if (role === "tf_operator") {
            this.goTo("/transport");
          }
        })
        .catch((error) => {
          let title = "";

          if (this.$i18n.locale === "cyr") {
            title =
              error.response.data?.uz || `Хатолик ${error.response.status}`;
          } else {
            title =
              error.response.data?.ru || `Ошибка ${error.response.status}`;
          }

          this.$notify({ title, type: "error" });
        })
        .finally(() => {
          this.loadingOneID = false;
        });
    },
    getOneIdUrl() {
      this.loadingOneIdUrl = true;
      axios
        .get("/services/auth/oneid/url/", {
          headers: {
            Authorization: "", // Tokenni butunlay olib tashlash
          },
        })
        .then((response) => {
          this.oneIdUrl = response.data.url;
        })
        .catch(() => {
          this.$notify({
            title: "Хато",
            message: "Логин ёки пароль нотўгри киритилган",
            type: "error",
          });
        })
        .finally(() => {
          this.loadingOneIdUrl = false;
        });
    },
    goToOneID() {
      if (!this.loadingOneID && this.oneIdUrl) {
        window.location.href = this.oneIdUrl;
      }
    },
  },
};
</script>

<style lang="scss">
.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 30px;
  justify-content: center;
  position: relative;
  background: #f8fafc;
  font-family: "Nunito", sans-serif;

  .login__wrapper {
    width: 1342px;
    display: flex;
    border-radius: 32px;
    background: #ffffff;
    box-shadow: 0px 32px 64px 0px #00000014;
    padding: 40px;

    .login__left {
      width: 407px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      min-height: 100%;

      .login__logo {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f8fafc;
        border-radius: 20px;
        padding: 20px;
        gap: 8px;

        .login__logo-icon {
          width: 80px;
          height: 80px;
          .login__logo-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .login__logo-text {
          font-size: 40px;
          font-weight: 900;
          line-height: 80%;
          letter-spacing: 0;
          font-family: "Orbitron", sans-serif;
          .login__logo-title {
            color: #3730a3;
          }
          .login__logo-subtitle {
            color: #0891b2;
          }
        }
      }
      .login__welcome {
        text-align: center;
        .login__welcome-title {
          color: #0891b2;
          font-weight: 700;
          font-size: 32px;
          line-height: 44px;
        }
        .login__welcome-subtitle {
          color: #94a3b8;
          line-height: 22px;
          margin-top: 8px;
        }
      }

      .login__form {
        display: flex;
        flex-direction: column;
        .login__form-group {
          display: flex;
          flex-direction: column;
          position: relative;
          margin-bottom: 20px;
          .login__label {
            margin-bottom: 6px;
            line-height: 22px;
            color: #1e293b;
            font-weight: 600;
          }
          .login__input {
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            padding: 8px 12px;
            box-shadow: 0px 1px 2px 0px #0000000d;
            font-size: 14px;
            height: 40px;
            outline: none;
          }
          .is-error {
            border: 1px solid #dc2626;
          }
          .eye_open {
            position: absolute;
            right: 12px;
            bottom: 20px;
            transform: translateY(50%);
            cursor: pointer;
          }
          .eye_close {
            position: absolute;
            right: 12px;
            bottom: 20px;
            transform: translateY(50%);
            cursor: pointer;
          }
        }
        .login__options {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
          .login__remember {
            color: #020617;
            cursor: pointer;
            user-select: none;
            line-height: 22px;
            input {
              border: 1px solid #cbd5e1;
            }
          }
          .login__forgot {
            color: #0891b2;
            font-weight: 700;
            line-height: 22px;
          }
        }
        .login__actions {
          .login__btn {
            width: 100%;
            background: #3730a3;
            color: #ffffff;
            border-radius: 12px;
            height: 40px;
            font-weight: 600;
            line-height: 22px;
            display: flex;
            gap: 8px;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .login__divider {
        display: flex;
        align-items: center;
        text-align: center;
        color: #94a3b8; /* kulrang rang */
        line-height: 22px;

        &::before,
        &::after {
          content: "";
          flex: 1;
          border-bottom: 1px solid #94a3b8; /* chiziq rangi */
        }

        &::before {
          margin-right: 20px;
        }

        &::after {
          margin-left: 20px;
        }
      }
      .login__oneid {
        background: #f8fafc;
        border-radius: 16px;
        padding: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .login__oneid-text {
        line-height: 22px;
        color: #94a3b8;
        text-align: center;
      }
    }

    .login__right {
      margin-left: 40px;
      flex: 1;
      min-height: 100%;
      background: #f8fafc;
      border-radius: 20px;
      .login__info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 32px;
        height: 100%;
        .login__info-img {
          width: 200px;
          height: 200px;
          .login__info-logo {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .login__info-text {
          text-align: center;
          color: #475569;
          font-weight: 700;
          font-size: 24px;
          line-height: 33px;
          span {
            display: block;
          }
          .login__info-cyan {
            color: #0891b2;
          }
          .login__info-indigo {
            color: #3730a3;
          }
        }
        .login__icons {
          display: flex;
          align-items: center;
          justify-content: center;
          .login-icons-img {
            color: #cbd5e1;
            svg {
              width: 40px;
              height: 40px;
            }
            &:not(:last-child) {
              margin-right: 8px;
              display: flex;
              align-items: center;
              &::after {
                content: "•";
                margin-left: 8px;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1100px) {
  .login {
    padding: 30px;
    .login__wrapper {
      width: max-content;
      padding: 28px;
      border-radius: 16px;
      max-width: 100%;
      .login__left {
        .login__logo {
          flex-direction: column;
          .login__logo-text {
            text-align: center;
          }
        }
      }
      .login__right {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 575px) {
  .login {
    padding: 12px;
    .login__wrapper {
      padding: 12px;
      .login__left {
        gap: 12px;
        .login__logo {
          padding: 12px;
          .login__logo-icon {
            width: 70px;
            height: 70px;
          }
          .login__logo-text {
            font-size: 36px;
          }
        }
        .login__welcome {
          .login__welcome-title {
            font-size: 28px;
            line-height: 1.375;
          }
          .login__welcome-subtitle {
            margin-top: 4px;
            font-size: 14px;
          }
        }
        .login__form {
          .login__form-group {
            margin-bottom: 12px;
            .login__label {
              margin-bottom: 4px;
            }
          }
          .login__options {
            margin-bottom: 12px;
          }
        }
      }
      .login__right {
        display: none;
      }
    }
  }
}
</style>
